import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { observer } from 'mobx-react';

import { Helmet } from 'react-helmet';

import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';

import Plate from 'components/UI/Plate/Plate';
import Button from 'components/UI/Button/Button';
import { TextInput } from 'components/UI/TextInput/TextInput';

import messageBoxStore from 'MessageBox/MessageBoxStore';

import client, { ApiError } from 'client';

import {
  SMART_CAPTCHA_KEY,
  SMART_CAPTCHA_TEST,
} from 'smart-captcha.js';

import './Restore.scss';

export const Restore = observer(() => {

  const navigate = useNavigate();

  const [isBusy, setIsBusy] = useState(false);
  const [login, setLogin] = useState('');

  const [captchaKey, setCaptchaKey] = useState(0);
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaVisible, setCaptchaVisible] = useState(false);

  async function onSubmit() {
    if (isBusy || captchaVisible)
      return;

    if (!login)
      return messageBoxStore.showError('Введите email');

    if (SMART_CAPTCHA_KEY)
      return setCaptchaVisible(true);
    onCaptchaSuccess(captchaToken);
  }

  async function onCaptchaSuccess(captchaToken) {
    setCaptchaVisible(false);
    setCaptchaToken(captchaToken);

    setIsBusy(true);
    try {
      await client.restore({ login, captcha: captchaToken });
    } catch (e) {
      setCaptchaKey(captchaKey + 1);
      if (e instanceof ApiError) {
        messageBoxStore.showError(e.message);
        return;
      }
      throw e;
    } finally {
      setIsBusy(false);
    }

    messageBoxStore.showInfo(
      'Письмо отправлено',
      'Если такой пользователь зарегистрирован, будет отправлена ссылка для восстановления'
    );
    navigate('/');
  }

  return (
    <div className='restore_page'>
      <Helmet>
        <title>Сброс пароля в сервисе — Boostclick</title>
        <meta name="description" content="Сброс пароля в Boostclick" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href={window.location.origin + window.location.pathname} />
      </Helmet>

      <div className='restore'>
        <form className="restore__form" onSubmit={e => { e.preventDefault(); onSubmit() }}>
          <Plate className='restore__plate'>
            <h1 className='restore__title'>Восстановление пароля</h1>
            <p className='restore__text'>
              Введите Email, на который был зарегестрирован аккаунт.
              Мы отправим на него временную ссылку для восстановления пароля.
            </p>

            <TextInput classes={["restore__input"]}  placeholder='Email' type='email' onChange={e => setLogin(e.target.value)} />

            <Button title='Получить письмо с ссылкой' />
          </Plate>
        </form>
      </div>

      {SMART_CAPTCHA_KEY && <InvisibleSmartCaptcha
        key={captchaKey}
        sitekey={SMART_CAPTCHA_KEY}
        test={SMART_CAPTCHA_TEST}
        visible={captchaVisible}
        hideShield={true}
        onSuccess={onCaptchaSuccess}
        onTokenExpired={() => setCaptchaToken('')}
        onNetworkError={() => setCaptchaVisible(false)}
        onChallengeHidden={() => setCaptchaVisible(false)}
      />}

    </div>
  );
});
